import React from 'react';
import FastLinks from '../FastLinks';
import MenuContent from '../MenuContent';
import NavList from '../NavList';

const Sandals = ({resorts}) => (
  <div className="col-lg-3 resorts-list-content">
    {
      resorts.map(resort => {
        const { country, resortList } = resort;

        return (
          <NavList key={country.label}>
            <h4>
              <a href={country.link}>{country.label}</a>
            </h4>

            <ul key={country}>
              {
                resortList.map(rst => (
                  <li key={rst.value}>
                    <a href={rst.link}>
                      <span className="brand">Sandals</span> {rst.resortName} {rst.isNew && <span className="is-all-new">ALL-NEW</span>}
                    </a>
                  </li>
                ))
              }
            </ul>
          </NavList>
        );
      })
    }
  </div>
);

const Beaches = ({resorts}) => (
  <div className="sm-12 util-txt-center">
    <div className="row">
      {resorts.map(resort => (
        <div key={`bchs-${resort.resortName}`} className="lg-4 md-12 sm-12 resort-item">
          <a href={resort.link}>
            <div className="resort-info">
              <i className="icon-new-beaches" />
              <h4 className="resort-name">
                {resort.resortName}
              </h4>
              <span className="resort-location">{resort.resortRegion}</span>
            </div>
            <img src={resort.img} alt={resort.resortRegion} />
          </a>
        </div>
      ))}
    </div>
  </div>
);

const ResortsBlock = ({ resorts, fastLinks }) => {

  const { isSandals, isBeaches } = window._app.brandOptions;

  return (
    <MenuContent className={isBeaches ? 'resorts-block' : ''}>
      <div className="resorts-list row">
        {
          isSandals ?
            <Sandals resorts={resorts} /> :
            <Beaches resorts={resorts} />
        }
      </div>
      <FastLinks data={fastLinks} />
    </MenuContent>
  );
};

ResortsBlock.defaultProps = {
  resorts: [],
  fastLinks: [],
};

export default ResortsBlock;



// WEBPACK FOOTER //
// ./js/components/global/menu/menuBlocks/ResortsBlock.js